module.exports = __webpack_public_path__ + "static/media/residencialIcon.e49f5999.svg";